// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownChevron-module__iconContainer--oTMxN{height:30px;width:28px;display:flex;align-items:center;justify-content:center;cursor:pointer}.DropDownChevron-module__icon--oi2jP{cursor:pointer;flex-shrink:0;fill:#7b7f83}.DropDownChevron-module__icon--oi2jP:hover{fill:#a8abae}.DropDownChevron-module__icon--oi2jP.DropDownChevron-module__chevron--UZFzZ{width:9px;height:5px}.DropDownChevron-module__icon--oi2jP.DropDownChevron-module__chevron--UZFzZ.DropDownChevron-module__is-open--J84le{transform:rotate(180deg)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `DropDownChevron-module__iconContainer--oTMxN`,
	"icon": `DropDownChevron-module__icon--oi2jP`,
	"chevron": `DropDownChevron-module__chevron--UZFzZ`,
	"is-open": `DropDownChevron-module__is-open--J84le`,
	"isOpen": `DropDownChevron-module__is-open--J84le`
};
export default ___CSS_LOADER_EXPORT___;
